import mapImg from './images/blogpage/map.jpg';
import agencyImg from './images/blogpage/agency.png';
import agencyitImg from './images/blogpage/agencyit.png';
import etfsImg from './images/blogpage/etfs.png';
import etfImg from './images/blogpage/etf.png';
import fraudsImg from './images/blogpage/frauds.png';
import foreignImg from './images/blogpage/foreign.png';
import stocksImg from './images/blogpage/stocks.png';
import banksImg from './images/blogpage/banks.png';
import emergencyImg from './images/blogpage/emergency1.png';
import custodialImg from './images/blogpage/minor.png';
import minorImg from './images/blogpage/custodial.png';
import cardImg from './images/blogpage/card.png'
import loungeImg from './images/blogpage/lounges.png'

const guides = [ 
  {
    id: "corretora-eua",
    title: {
      en: "📘 How to Open a U.S. Brokerage Account",
      pt: "📘 Como Abrir Conta em Corretora nos EUA"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/corretoraeua_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/corretoraeua_pt.md",
    },
    category: "Getting Started in the U.S. Market",
    image: agencyImg
  },
  {
    id: "corretora-euasemssn",
    title: {
      en: "📘 How to Open Your First Brokerage Account in the U.S. Without SSN or ITIN",
      pt: "📘 Como Abrir Sua Primeira Conta em Corretora nos EUA Sem SSN ou ITIN"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/corretoraeuasemssn_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/corretoraeuasemssn_pt.md",
    },
    category: "Getting Started in the U.S. Market",
    image: agencyitImg
  },
  {
    id: "popular-banks",
    title: {
      en: "📘 Key Differences Between the Most Popular U.S. Brokerages and Banks",
      pt: "📘 Diferenças entre as Corretoras e Bancos mais famosos nos EUA"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/banks_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/banks_pt.md",
    },
    category: "Getting Started in the U.S. Market",
    image: banksImg
  },
  {
    id: "enviar-dinheiro",
    title: {
      en: "📘 How to Send Money from Brazil to a U.S. Brokerage Account",
      pt: "📘 Como Enviar Dinheiro do Brasil para Corretora nos EUA"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/sendmoney_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/sendmoney_pt.md",
    },
    category: "Getting Started in the U.S. Market",
    image: mapImg
  },
  {
    id: "escolher-etf",
    title: {
      en: "📘 How to Choose Your First Stocks or ETFs",
      pt: "📘 Como Escolher Suas Primeiras Ações ou ETFs"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/comoEscolherEtf_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/comoEscolherETF_pt.md",
    },
    category: "Choosing What to Invest In",
    image: etfImg
  },
  {
    id: "hyatt-card",
    title: {
      en: "📘 How to Use Points to Stay at 5⭐ Hotels for Free",
      pt: "📘 Como usar pontos para ficar em hotéis 5⭐ de graça"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/pontos_hyatt_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/pontos_hyatt_pt.md",
    },
    category: "Choosing What to Invest In",
    image: cardImg
  },
  {
    id: "club-lounge",
    title: {
      en: "📘 How to Access Airport Lounge Clubs for Free ✈️",
      pt: "📘 Como acessar salas VIP de aeroportos de graça ✈️"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/lounge_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/lounge_pt.md",
    },
    category: "Choosing What to Invest In",
    image: loungeImg
  },
  {
    id: "etf-oquee",
    title: {
      en: "📘 What Is an ETF and How Does It Work",
      pt: "📘 O Que É e Como Funciona um ETF"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/etf_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/etf_pt.md",
    },
    category: "Understanding the Market",
    image: etfsImg
  },
  {
    id: "diferencas-acoes",
    title: {
      en: "📘 Differences Between the Stock Markets in Brazil and the USA",
      pt: "📘 Diferenças Entre o Mercado de Ações no Brasil e nos EUA"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/differences_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/differences_pt.md",
    },
    category: "Understanding the Market",
    image: stocksImg
  },
  {
    id: "golpes-fraudes",
    title: {
      en: "📘 How to Avoid Scams and Investment Fraud",
      pt: "📘 Como Evitar Golpes e Fraudes em Investimentos"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/golpes_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/golpes_pt.md",
    },
    category: "Safety and Compliance",
    image: fraudsImg
  },
  {
    id: "impostos",
    title: {
      en: "📘 How to Report Foreign Investments (for Brazilian Residents)",
      pt: "📘 Como Declarar Investimentos no Exterior (para Brasileiros)"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/impostos_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/impostos_pt.md",
    },
    category: "Safety and Compliance",
    image: foreignImg
  },
  {
    id: "emergencia",
    title: {
      en: "📘 How to Build an Emergency Fund in the U.S.",
      pt: "📘 Como Montar Sua Reserva de Emergência nos EUA"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/emergencyfund_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/emergencyfund_pt.md",
    },
    category: "Getting Started in the U.S. Market",
    image: emergencyImg
  },
  {
    id: "custodial",
    title: {
      en: "📘 Custodial Accounts: Investing in Your Child’s Name in the U.S.",
      pt: "📘  Custodial Accounts: o investimento no nome dos filhos nos EUA"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/contacustodial_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/contacustodial_pt.md",
    },
    category: "Understanding the Market",
    image: custodialImg
  },
  {
    id: "minors-account",
    title: {
      en: "📘 Accounts for Minors in the U.S.",
      pt: "📘  Contas para Menores nos EUA"
    },
    url: {
      en: "https://downloads27.s3.us-west-2.amazonaws.com/contaparamenores_en.md",
      pt: "https://downloads27.s3.us-west-2.amazonaws.com/contaparamenores_pt.md",
    },
    category: "Understanding the Market",
    image: minorImg
  },
];


export default guides;

